import { parsePhoneNumberFromString } from 'libphonenumber-js';
import axios from 'axios';

import { EmployeeRead } from '../interfaces/emd/employeeRead';
import { TeamData } from '../interfaces/emd/teamData';
import { StructuredContent } from '../interfaces/liferay/rest/structuredContents';
import { determineLocale } from '../helpers/locale';

const RM_PATH = '/delegate/rm-resolver/v1';
const EMD_PATH = '/delegate/employee-master-data/v2';
const CMD_PATH = '/delegate/customer-master-data/v3';
const LIFERAY_SC_PATH = '/o/headless-delivery/v1.0';

declare global {
  interface Window {
    Liferay: any;
  }
}

window.Liferay = window.Liferay || {};

const locale = determineLocale().replace('_', '-');

export const loadEMD = async (): Promise<void> => {
  const $EMD_NAME = $('.emd-name');
  const $EMD_IMAGE = $('.emd-image');
  const $EMD_POSITION = $('.emd-position');
  const $EMD_CHAT_NAME_FIELD = $('#contact-floating-panel-content-chat');
  const $EMD_CHAT_NAME = $('#contact-floating-panel-content-chat-name');

  const $EMD_PHONE = $('.emd-phone');
  const $EMD_PHONE_INNER = $('.emd-phone-inner');
  const $EMD_MAIL = $('.emd-mail');
  const $EMD_BRANCH = $('.emd-branch');

  if ($EMD_NAME.length === 0) {
    return;
  }

  const rmResponse = await axios.get<{ id: string; type: string }>(
    `${RM_PATH}/relationship-managers?authenticated=true`,
  );
  const rm = rmResponse.data;

  const emdResponse = await axios.get<EmployeeRead>(`${EMD_PATH}/employees/${rm.id}`);
  const employee = emdResponse.data;

  const { firstName, lastName, jobTitle, officePhoneNumber, officeEmail } = employee;
  const jobTitleName = jobTitle?.name;
  const fullEMDName = `${firstName ? firstName : ''} ${lastName ? lastName : ''}`;
  const phoneNumber = officePhoneNumber?.subscriberNumber
    ? parsePhoneNumberFromString(officePhoneNumber.subscriberNumber, 'CH').formatInternational()
    : undefined;

  $EMD_NAME.text(fullEMDName);

  if (jobTitleName) {
    $EMD_POSITION.text(jobTitleName);
  }

  if ($EMD_PHONE.length !== 0 && phoneNumber) {
    $EMD_PHONE_INNER.text(phoneNumber);
    $EMD_PHONE.attr('href', `tel:${phoneNumber}`);
  }

  if ($EMD_MAIL.length !== 0 && officeEmail) {
    $EMD_MAIL.attr('href', `mailto:${officeEmail}`);
  }

  if (employee.mainTeamId) {
    const teamId = employee.mainTeamId;

    const teamReponse = await axios.get<TeamData>(`${EMD_PATH}/teams/${teamId}`);
    const teamData = teamReponse.data;

    if ($EMD_BRANCH.length !== 0 && teamData.branchId) {
      const branchesURL = $EMD_BRANCH.attr('href');
      $EMD_BRANCH.attr('href', `${branchesURL}#/details${teamData.branchId}`);
    }
  }

  if (rm.id) {
    try {
      const siteGroupId = window.Liferay.ThemeDisplay.getSiteGroupId();
      const rmId = rm.id.toUpperCase();

      const config = {
        headers: {
          'Accept-Language': locale,
        },
      };

      const liferayEmployeeData = await axios.get<StructuredContent>(
        `${LIFERAY_SC_PATH}/sites/${siteGroupId}/structured-contents/by-key/${rmId}`,
        config,
      );

      const liferayEmployee = liferayEmployeeData.data;
      const imagePath = liferayEmployee.contentFields.find(emp => emp.name === 'photo').contentFieldValue.image
        .contentUrl;

      if (imagePath && imagePath.length > 0) {
        $EMD_IMAGE.attr('src', imagePath);
      } else {
        $EMD_IMAGE.hide();
      }
    } catch (error) {
      $EMD_IMAGE.hide();
    }
  }

  if ($EMD_CHAT_NAME.length > 0) {
    try {
      const cmdResponse = await axios.get<{ firstName: string; lastName: string }[]>(
        `${CMD_PATH}/persons?owner-only=true`,
      );

      if (cmdResponse?.data?.length > 0) {
        const CMD_USER = cmdResponse.data[0];
        const fullCMDName = `${CMD_USER.firstName} ${CMD_USER.lastName}`;
        $EMD_CHAT_NAME.val(fullCMDName);
      }
    } catch (_error) {
      $EMD_CHAT_NAME_FIELD.show();
    }
  }
};
